import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import ProtectedRoute from "./components/auth/ProtectedRoute.jsx";
import LoginPage from "./pages/LoginPage/LoginPage.jsx";
import Layout from "./components/Layout.jsx";
import InsuredLoginPage from "./pages/Insured/InsuredLoginPage.jsx";
import { USER_ROLES } from "./utils/authSession";

const DashboardAdmin = lazy(() => import("./HeadOffice/Pages/Dashboard/DashboardAdmin.jsx"));
const ClaimReportAdmin = lazy(() => import("./HeadOffice/Pages/ClaimReport/ClaimReport.jsx"));
const ClaimDetailPage = lazy(() => import("./HeadOffice/Pages/ClaimDetail/headClaimDetailPage.jsx"));
const ProfilePage = lazy(() => import("./pages/Profile Page/ProfilePage.jsx"));
const DashboardBranch = lazy(() => import("./pages/Dashboard/BranchOffice/DashboardBranch.jsx"));
const ClaimReportBranch = lazy(() => import("./BranchOffice/Pages/ClaimReport/ClaimReport.jsx"));
const ClaimReportBranchDetail = lazy(() => import("./BranchOffice/Pages/ClaimReportDetail/branchClaimReportDetail.jsx"));
const UserAdministrator = lazy(() => import("./BranchOffice/Pages/Administrator/userAdministrator.jsx"));
const BengkelPage = lazy(() => import("./pages/Bengkel/BengkelPage.jsx"));
const TambahBengkelPage = lazy(() => import("./pages/Bengkel/TambahBengkelPage.jsx"));
const BengkelTerdekatPage = lazy(() => import("./pages/Insured/BengkelTerdekatPage.jsx"));
const InsuredProfilePage = lazy(() => import("./pages/Insured/InsuredProfilePage.jsx"));
const AjukanKlaimPage = lazy(() => import("./pages/Insured/AjukanKlaimPage.jsx"));
const InsuredClaimListPage = lazy(() => import("./pages/Insured/InsuredClaimListPage.jsx"));
const InsuredClaimDetailPage = lazy(() => import("./pages/Insured/InsuredClaimDetailPage.jsx"));
const WorkshopDashboard = lazy(() => import("./pages/Workshop/WorkshopDashboard.jsx"));
const WorkshopProfilePage = lazy(() => import("./pages/Workshop/WorkshopProfilePage.jsx"));
const WorkshopClaimListPage = lazy(() => import("./pages/Workshop/WorkshopClaimListPage.jsx"));
const WorkshopClaimDetailPage = lazy(() => import("./pages/Workshop/WorkshopClaimDetailPage.jsx"));
const WorkshopEstimationPage = lazy(() => import("./pages/Workshop/WorkshopEstimationPage.jsx"));
const WorkshopRepairPage = lazy(() => import("./pages/Workshop/WorkshopRepairPage.jsx"));
const NotFound = lazy(() => import("./components/not-found.jsx"));

const RouteLoader = () => (
  <div className="d-flex align-items-center justify-content-center min-vh-100" role="status">
    <span className="spinner-border text-primary" aria-hidden="true" />
    <span className="visually-hidden">Memuat halaman...</span>
  </div>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteLoader />}>
        <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login/insured" element={<InsuredLoginPage />} />

        <Route element={<ProtectedRoute allowedRoles={[USER_ROLES.HEAD_OFFICE]} />}>
          <Route path="/dashboard-headoffice/*" element={<Layout type="headoffice" />}>
            <Route index element={<DashboardAdmin />} />
            <Route path="claim" element={<ClaimReportAdmin />} />
            <Route path="claim/report/detail/:id" element={<ClaimDetailPage />} />
            <Route path="bengkel" element={<BengkelPage />} />
            <Route path="bengkel/tambah" element={<TambahBengkelPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[USER_ROLES.BRANCH_OFFICE]} />}>
          <Route path="/dashboard-branch/*" element={<Layout type="branchoffice" />}>
            <Route index element={<DashboardBranch />} />
            <Route path="claim" element={<ClaimReportBranch />} />
            <Route path="administrator" element={<UserAdministrator />} />
            <Route path="claim/report/detail/:claimId" element={<ClaimReportBranchDetail />} />
            <Route path="bengkel" element={<BengkelPage />} />
            <Route path="bengkel/tambah" element={<TambahBengkelPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[USER_ROLES.INSURED]} />}>
          <Route path="/dashboard-insured/*" element={<Layout type="insured" />}>
            <Route path="bengkel" element={<BengkelTerdekatPage />} />
            <Route path="profile" element={<InsuredProfilePage />} />
            <Route path="klaim" element={<InsuredClaimListPage />} />
            <Route path="klaim/detail/:id" element={<InsuredClaimDetailPage />} />
            <Route path="klaim/ajukan" element={<AjukanKlaimPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={[USER_ROLES.WORKSHOP]} />}>
          <Route path="/dashboard-workshop/*" element={<Layout type="workshop" />}>
            <Route index element={<WorkshopDashboard />} />
            <Route path="klaim" element={<WorkshopClaimListPage />} />
            <Route path="klaim/detail/:id" element={<WorkshopClaimDetailPage />} />
            <Route path="klaim/detail/:id/estimasi" element={<WorkshopEstimationPage />} />
            <Route path="klaim/detail/:id/perbaikan" element={<WorkshopRepairPage />} />
            <Route path="profile" element={<WorkshopProfilePage />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
